module.exports = __webpack_public_path__ + "img/qr-codew.27636ff8.svg";